import { Button } from "@chakra-ui/react";
import { useMemo } from "react";
import { RiArrowUpDownLine } from "react-icons/ri";
import { SearchableMenuPopover } from "src/components/Popovers/SearchableMenuPopover";
import { useAvelaToast } from "src/hooks/useAvelaToast";
import { useEditFormTemplateContext } from "../../context";

type Props = { sectionId: string };
export const MoveSectionPopover: React.FC<Props> = ({ sectionId }) => {
  const context = useEditFormTemplateContext();
  const sections = context.state.get("draft").sections;

  const isNew = useMemo(() => {
    const diff = context.state.get("diff");
    return (
      diff.sections[sectionId] === "Insert" || // section was added and saved but not published yet
      context.helpers.isNewSection(sectionId) // section is new compared to last saved schema
    );
  }, [context.state, context.helpers, sectionId]);

  const toast = useAvelaToast();

  if (context.isPublishedMode && !isNew) {
    return null;
  }

  if (sections.length <= 1) {
    return null;
  }

  return (
    <SearchableMenuPopover
      title="Move before section"
      items={sections
        .filter((section) => section.id !== sectionId)
        .map((section) => ({
          key: section.id,
          label: section.title,
        }))}
      popoverTrigger={
        <Button
          leftIcon={<RiArrowUpDownLine />}
          variant="outline"
          colorScheme="gray"
        >
          Move section
        </Button>
      }
      onItemSelected={(selectedSection) => {
        toast.closeAll();
        context.dispatch({
          type: "MoveSection",
          sectionId,
          beforeSectionId: selectedSection.key,
        });
        toast({
          title: "Section moved",
        });
      }}
    />
  );
};
